<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle6')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle6') }}</h1>
    <p>{{ $t('artText6-1') }}</p>
    <p>{{ $t('artText6-2') }}</p>
    <h2>{{ $t('artText6-3') }}</h2>
    <p>{{ $t('artText6-4') }}</p>
    <img
      :src="`${staticUrl}/images/5_Best_Ideas_of_House_Exteriors.webp`"
      :alt="'altImageDefault'"
    />
    <h2>{{ $t('artText6-5') }}</h2>
    <p>{{ $t('artText6-6') }}</p>
    <h2>{{ $t('artText6-7') }}</h2>
    <p>{{ $t('artText6-8') }}</p>
    <h2>{{ $t('artText6-9') }}</h2>
    <p>{{ $t('artText6-10') }}</p>
    <p>{{ $t('artText6-11') }}</p>
    <h2>{{ $t('artText6-12') }}</h2>
    <p>{{ $t('artText6-13') }}</p>
    <h2>{{ $t('artText6-14') }}</h2>
    <p>{{ $t('artText6-15') }}</p>
    <h2>{{ $t('artText6-16') }}</h2>
    <p>{{ $t('artText6-17') }}</p>
    <img
      :src="`${staticUrl}/images/5_Best_Ideas_of_House_Exteriors_1.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText6-18') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle6')}`,
  ogTitle: `${t('artSeoTitle6')}`,
  description: `${t('artSeoDesc6')}`,
  ogDescription: `${t('artSeoDesc6')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
